export default __webpack_public_path__ + "static/media/3.1b7b0809.webp";